import { Cpu, Check, X } from 'lucide-react';
import React from 'react';

import { Notification } from '../../../types/notification';
import { Badge } from '../../ui/badge';
import { Button } from '../../ui/button';

interface ItemProps {
  notification: Notification;
  onAction: (n: Notification, handler: string) => void;
}

export const ZTPRequestItem: React.FC<ItemProps> = ({
  notification,
  onAction,
}) => {
  const { metadata } = notification;

  return (
    <div
      className={`relative flex gap-4 rounded-lg border p-4 transition-colors ${notification.read ? 'bg-background' : 'bg-muted/30 border-primary/20'}`}
    >
      <div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600'>
        <Cpu className='h-5 w-5' />
      </div>
      <div className='flex-1 space-y-1'>
        <div className='flex items-center justify-between'>
          <div className='text-sm font-medium leading-none'>
            {notification.title}
            {!notification.read && (
              <Badge
                variant='secondary'
                className='ml-2 text-[10px] bg-blue-100 text-blue-700 hover:bg-blue-100'
              >
                NEW
              </Badge>
            )}
          </div>
          <span className='text-xs text-muted-foreground'>
            {new Date(notification.timestamp).toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
            })}
          </span>
        </div>

        <p className='text-sm text-muted-foreground'>
          Agent <strong>{metadata?.fingerprint}</strong> ({metadata?.ip})
          requests enrollment.
        </p>

        <div className='flex gap-2 pt-2'>
          <Button
            size='sm'
            className='h-7 bg-blue-600 hover:bg-blue-700'
            onClick={() => onAction(notification, 'APPROVE_ZTP')}
          >
            <Check className='mr-1 h-3 w-3' /> Approve
          </Button>
          <Button
            size='sm'
            variant='outline'
            className='h-7 text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700'
            onClick={() => onAction(notification, 'REJECT_ZTP')}
          >
            <X className='mr-1 h-3 w-3' /> Reject
          </Button>
        </div>
      </div>
    </div>
  );
};
